import { render } from "./VisualizarPedido.vue?vue&type=template&id=662705f0&scoped=true"
import script from "./VisualizarPedido.vue?vue&type=script&lang=js"
export * from "./VisualizarPedido.vue?vue&type=script&lang=js"

import "./VisualizarPedido.vue?vue&type=style&index=0&id=662705f0&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-662705f0"]])

export default __exports__